import axios from '@/libs/api.request'
import uploadAxios from '@/libs/uploadAxios.js'
import urlObj from '@/config/env.js'

/**
 * 
 * @param {Object} data 
 * @param {Object} page
 * @returns 
 */
export const cliamList = (data,params) => {
  return axios.request({
    url: `${urlObj.wss}wss-order/claim/getBuyClaimList`,
    method:'post',
    data,
    params
  })
}

export const applyCliam = (params) => {
  return axios.request({
    url: `${urlObj.wss}wss-order/claim/getClaimDetail`,
    method:'get',
    params
  })
}

export const applyForClaim = (data) => {
  return axios.request({
    url: `${urlObj.wss}wss-order/claim/applyForClaim`,
    method:'post',
    data
  })
}
export const cliamInfo = (params) => {
  return axios.request({
    url: `${urlObj.wss}wss-order/claim/queryClaimDetail`,
    method:'get',
    params
  })
}
export const handleCliam = (data) => {
  return axios.request({
    url: `${urlObj.wss}wss-order/claim/revocationClaim`,
    method:'post',
    data
  })
}
export const finishCliam = (params) => {
  return axios.request({
    url: `${urlObj.wss}wss-order/claim/confirm`,
    method:'get',
    params
  })
}
export const downLoadCliam = (params) => {
  return uploadAxios.request({
    url: `${urlObj.wss}wss-order/claim/download`,
    method:'get',
    responseType: 'blob',
    params
  })
}
